import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import Pillola from './Pillola';
import {
  STATO_SONDA_MAI_VISTA,
  STATO_SONDA_SILENTE,
  STATO_SONDA_TRASMETTE,
  descriviStatoSonda,
  dettaglioStatoSonda,
} from './assegnazioniIotUtils';

const TONO_DI = {
  [STATO_SONDA_TRASMETTE]: 'success',
  [STATO_SONDA_SILENTE]: 'warning',
  [STATO_SONDA_MAI_VISTA]: 'neutral',
};

const useStyles = makeStyles((theme) => ({
  cella: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  senzaVerdetto: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  aiuto: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  bottoneAiuto: {
    padding: theme.spacing(0.25),
  },
  icona: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    cursor: 'help',
  },
  legenda: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.5, 0),
  },
}));

const LEGENDA = [
  [STATO_SONDA_TRASMETTE, 'la sonda sta mandando letture regolarmente.'],
  [
    STATO_SONDA_SILENTE,
    'la sonda ha trasmesso ma da qualche minuto non manda più letture: controlla batteria, gateway e che sia in portata. Il controllo non riceve temperature finché non riprende.',
  ],
  [
    STATO_SONDA_MAI_VISTA,
    'nessuna lettura negli ultimi 7 giorni: la sonda non è mai stata accesa, oppure è ferma da più di una settimana.',
  ],
  [null, 'lo stato della sonda non è disponibile in questo momento.'],
];

export const AiutoStatoSonda = ({ etichetta }) => {
  const classes = useStyles();
  return (
    <span className={classes.aiuto}>
      {etichetta}
      <Tooltip
        arrow
        placement="top"
        title={
          <div className={classes.legenda}>
            {LEGENDA.map(([stato, testo]) => (
              <Typography key={stato ?? 'nd'} variant="caption">
                <strong>{descriviStatoSonda({ statoSonda: stato })}</strong>:{' '}
                {testo}
              </Typography>
            ))}
          </div>
        }
      >
        <IconButton
          size="small"
          className={classes.bottoneAiuto}
          aria-label="Cosa vuol dire lo stato di trasmissione"
        >
          <HelpOutline className={classes.icona} />
        </IconButton>
      </Tooltip>
    </span>
  );
};

AiutoStatoSonda.propTypes = {
  etichetta: PropTypes.node.isRequired,
};

const StatoSondaBadge = ({ assegnazione }) => {
  const classes = useStyles();
  const stato = assegnazione.statoSonda;

  return (
    <div className={classes.cella}>
      <Tooltip title={dettaglioStatoSonda(assegnazione)} arrow>
        {TONO_DI[stato] ? (
          <Pillola tono={TONO_DI[stato]} tabIndex={0}>
            {descriviStatoSonda(assegnazione)}
          </Pillola>
        ) : (
          <span tabIndex={0} className={classes.senzaVerdetto}>
            {descriviStatoSonda(assegnazione)}
          </span>
        )}
      </Tooltip>
    </div>
  );
};

StatoSondaBadge.propTypes = {
  assegnazione: PropTypes.shape({
    statoSonda: PropTypes.string,
    ultimaTrasmissione: PropTypes.string,
  }).isRequired,
};

export default StatoSondaBadge;
